/* ============
 * Dutch Language File
 * ============
 *
 * An example language file.
 */

import * as common from './common.json';
import * as auth from './auth.json';
import * as invoice from './invoice.json';
import * as company from './company.json';
import * as customer from './customer.json';
import * as login from './login.json';
import * as product from './product.json';

export default {
    common,
    auth,
    invoice,
    company,
    customer,
    product,
    login,
};



// WEBPACK FOOTER //
// ./src/locale/nl/index.js